import { CFTokens } from '../../../tokens';
export const CAPTION_COLOR = {
    DEFAULT: CFTokens.COLOR.TEXT_AND_ELEMENT_HINT,
    ERROR: CFTokens.COLOR.TEXT_AND_ELEMENT_DANGER,
    VALIDATED: CFTokens.COLOR.TEXT_AND_ELEMENT_SUCCESS,
};
export const LABEL_COLOR = CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT;
export const TYPE_SPEC = {
    CAPTION: CFTokens.TYPE_SPEC.BODY_2,
    LABEL: CFTokens.TYPE_SPEC.BODY_BOLD,
};
